import {TrustAccountActivityType} from '@sollapay/enums';

import type {IconName} from '@sollapay/ui';

/**
 * Icon per activity type — the single type→icon mapping, so rows that share a layout (e.g. a
 * completed transaction and the instruction that preceded it) don't each carry a ternary.
 */
export const ACTIVITY_ICONS: Partial<Record<TrustAccountActivityType, IconName>> = {
  [TrustAccountActivityType.BUYER_DEPOSIT]: 'sollapay:payin',
  [TrustAccountActivityType.BUYER_OVERPAYMENT]: 'sollapay:payin',
  [TrustAccountActivityType.PAYMENT_INSTRUCTION_SENT]: 'sollapay:initiate-payment',
  [TrustAccountActivityType.TRUST_PAYOUT]: 'sollapay:payout',
  [TrustAccountActivityType.PAYOUT_INSTRUCTION_SENT]: 'sollapay:hand-box'
};

/** Instructions are requests, not money movements — their amount renders as a pending badge. */
export const REQUEST_ACTIVITY_TYPES: ReadonlySet<TrustAccountActivityType> = new Set([
  TrustAccountActivityType.PAYMENT_INSTRUCTION_SENT,
  TrustAccountActivityType.PAYOUT_INSTRUCTION_SENT
]);
